import { Controller } from "stimulus"

// Bugfix 21 (#1391): een vragenlijst per vraag doorlopen ("Vraag 1 van 5").
// Zonder JavaScript staan alle vragen onder elkaar met één verzendknop; dit
// verbergt de andere vragen en controleert verplichte vragen voordat de
// sporter verder gaat. De server controleert daarna nog eens.
export default class extends Controller {
  static targets = ["stap", "teller", "balk", "vorige", "volgende", "verstuur", "fout"]
  static values = { teller: String, verplicht: String }

  connect() {
    if (this.stapTargets.length < 2) return

    const eersteFout = this.stapTargets.findIndex((stap) => stap.classList.contains("is-fout"))
    this.index = eersteFout >= 0 ? eersteFout : 0
    this.tellerTarget.hidden = false
    this.balkTarget.hidden = false
    this.toon()
  }

  vorige() {
    if (this.index > 0) {
      this.index -= 1
      this.toon()
    }
  }

  volgende() {
    if (!this.controleer(this.index)) return
    if (this.index < this.stapTargets.length - 1) {
      this.index += 1
      this.toon()
    }
  }

  versturen(event) {
    const ontbrekend = this.stapTargets.findIndex((_, i) => !this.controleer(i))
    if (ontbrekend >= 0) {
      event.preventDefault()
      if (this.stapTargets.length > 1) {
        this.index = ontbrekend
        this.toon()
      }
    }
  }

  toon() {
    const totaal = this.stapTargets.length
    this.stapTargets.forEach((stap, i) => { stap.hidden = i !== this.index })
    this.tellerTarget.textContent = this.tellerValue
      .replace("%{nummer}", this.index + 1)
      .replace("%{totaal}", totaal)
    this.balkTarget.firstElementChild.style.width = `${((this.index + 1) / totaal) * 100}%`
    this.vorigeTarget.hidden = this.index === 0
    const laatste = this.index === totaal - 1
    this.volgendeTarget.hidden = laatste
    this.verstuurTarget.hidden = !laatste
    const eerste = this.stapTargets[this.index].querySelector("input:not([type=hidden]), textarea, select")
    if (eerste && this.gestart) eerste.focus({ preventScroll: true })
    this.gestart = true
  }

  // Is de verplichte vraag op deze plek beantwoord?
  controleer(i) {
    const stap = this.stapTargets[i]
    const fout = this.foutTargets[i]
    if (stap.dataset.verplicht !== "true") return true

    const velden = Array.from(stap.querySelectorAll("input:not([type=hidden]), textarea, select"))
    const beantwoord = velden.some((veld) => {
      if (veld.type === "radio" || veld.type === "checkbox") return veld.checked
      return veld.value.trim() !== ""
    })
    stap.classList.toggle("is-fout", !beantwoord)
    if (fout) fout.hidden = beantwoord
    return beantwoord
  }
}
